import { render, staticRenderFns } from "./StateChip.vue?vue&type=template&id=e0d6e542&"
import script from "./StateChip.vue?vue&type=script&lang=ts&setup=true&"
export * from "./StateChip.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports